import { useApolloClient } from '@apollo/client';
import { getBookingCartUid, getBookingCartUidMap } from 'Common/functions/BookingCart';
import getBookingCartByUid, { GetBookingCartByUid } from 'Common/functions/getBookingCartByUid';
import { useEffect, useState } from 'react';

const useBookingCartCookie = (key: string): [
    GetBookingCartByUid | undefined,
    boolean,
  ] => {
  const bookingCartUidMap = getBookingCartUidMap();
  const bookingCartUid = getBookingCartUid(bookingCartUidMap, key);
  const [isLoading, setIsLoading] = useState(true);
  const [bookingCart, setBookingCart] = useState<GetBookingCartByUid | undefined>(undefined);
  const client = useApolloClient();

  useEffect(() => {
    if (bookingCartUid) {
      getBookingCartByUid(
        client.query,
        undefined,
        bookingCartUid,
      ).then(cart => {
        if (cart) {
          setBookingCart(cart);
        }
      }).finally(() => setIsLoading(false));
    } else {
      setIsLoading(false);
    }
  }, [bookingCartUid]);

  return [bookingCart, isLoading];
};

export default useBookingCartCookie;

